import { NgModule } from '@angular/core';
import { UspLinkComponent } from './usp-link.component';

@NgModule({
  declarations: [UspLinkComponent],
  exports: [UspLinkComponent],
})
export class UspLinkModule {}
